// import React, { useState, useEffect } from 'react'
// import Select from 'react-select'
// import classNames from 'classnames'
// import './genericSelect.css'

// export const GenericSelect = React.forwardRef(({
//   onSelectChange,
//   placeholder,
//   multi = false,
//   values,
//   name,
//   closeMenu = true,
//   setValue,
//   preValue,
//   placeholderAsOption = false,
//   selectClass
// }, ref) => {

//   const [selectedOption, setSelectedOption] = useState(null)
//   const [touched, setTouched] = useState(false)
//   const [isPreValueSet, setIsPreValueSet] = useState(false)

//   // 🔁 Avisar cambios hacia afuera (opcional)
//   useEffect(() => {
//     if (onSelectChange) {
//       onSelectChange(selectedOption)
//     }
//   }, [selectedOption, onSelectChange])

//   // ✅ Cambio manual del usuario
//   const handleChange = (option) => {
//     setSelectedOption(option)

//     if (Array.isArray(option)) {
//       setValue(name, option.map(o => o.value))
//     } else {
//       setValue(name, option?.value ?? null)
//     }
//   }

//   // 🧠 Opciones con placeholder como opción (si aplica)
//   const getValues = () => {
//     if (!values) return values

//     let result = [...values]

//     if (placeholder && placeholderAsOption) {
//       result.unshift({
//         value: '',
//         label: placeholder
//       })
//     }

//     return result
//   }

//   // ⭐ PREVALUE (la parte CLAVE)
//   useEffect(() => {
//     if (preValue && !isPreValueSet) {
//       setSelectedOption(preValue)

//       if (multi) {
//         setValue(name, preValue.map(p => p.value))
//       } else {
//         setValue(name, preValue.value)
//       }

//       // 👇 CLAVE: NO marcar como tocado
//       setTouched(false)
//       setIsPreValueSet(true)
//     }
//   }, [preValue, isPreValueSet, name, setValue, multi])

//   // ❗ Error SOLO si el usuario tocó y está vacío
//   const showError =
//     touched &&
//     (
//       !selectedOption ||
//       (Array.isArray(selectedOption) && selectedOption.length === 0)
//     )

//   const handleBlur = () => {
//     setTouched(true)
//   }

//   return (
//     <div className="App w-100">
//       <Select
//         ref={ref}
//         name={name}
//         value={selectedOption}
//         onChange={handleChange}
//         onBlur={handleBlur}
//         options={getValues()}
//         placeholder={placeholder}
//         isMulti={multi}
//         isSearchable
//         closeMenuOnSelect={closeMenu}
//         className={classNames(selectClass)}
//         styles={{
//           control: (base) => ({
//             ...base,
//             borderRadius: "22px",
//             borderColor: showError ? "#F06292" : base.borderColor,
//             backgroundColor: showError ? "#fdefef" : base.backgroundColor,
//             boxShadow: "none"
//           })
//         }}
//       />

//       {showError && (
//         <span className="invalid-feedback d-flex field-validation-error">
//           <span className="error-message">Campo requerido</span>
//         </span>
//       )}
//     </div>
//   )
// })




import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import classNames from 'classnames'
import './genericSelect.css'

export const GenericSelect = React.forwardRef(({
  onSelectChange,
  placeholder,
  multi = false,
  values = [],
  name,
  closeMenu = true,
  setValue,
  preValue,
  placeholderAsOption = false,
  selectClass
}, ref) => {

  const [selectedOption, setSelectedOption] = useState(() => {
    if (!preValue) return multi ? [] : null
    return preValue
  })

  const [touched, setTouched] = useState(false)

  // Sync con RHF
  useEffect(() => {
    if (!selectedOption) return

    if (multi) {
      setValue(name, selectedOption.map(o => o.value), {
        shouldValidate: true,
        shouldDirty: false
      })
    } else {
      setValue(name, selectedOption.value, {
        shouldValidate: true,
        shouldDirty: false
      })
    }
  }, [selectedOption, name, setValue, multi])

  const handleChange = (option) => {
    setSelectedOption(option)
    setTouched(false)

    if (Array.isArray(option)) {
      setValue(name, option.map(o => o.value), { shouldDirty: true })
    } else {
      setValue(name, option?.value ?? null, { shouldDirty: true })
    }
  }

  const hasValue = multi
    ? Array.isArray(selectedOption) && selectedOption.length > 0
    : !!selectedOption

  const showError = touched && !hasValue

  return (
    <div className="App w-100">
      <Select
        ref={ref}
        name={name}
        value={selectedOption}
        onChange={handleChange}
        onBlur={() => setTouched(true)}
        options={values}
        placeholder={placeholder}
        isMulti={multi}
        isSearchable
        closeMenuOnSelect={closeMenu}
        className={classNames(selectClass)}
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "22px",
            borderColor: showError ? "#F06292" : base.borderColor,
            backgroundColor: showError ? "#fdefef" : base.backgroundColor,
            boxShadow: "none"
          })
        }}
      />

      {showError && (
        <span className="invalid-feedback d-flex field-validation-error">
          <span className="error-message">Campo requerido</span>
        </span>
      )}
    </div>
  )
})
